import { render, staticRenderFns } from "./ExchangePrizeDialog.vue?vue&type=template&id=8667d3ea&scoped=true&"
import script from "./ExchangePrizeDialog.vue?vue&type=script&lang=js&"
export * from "./ExchangePrizeDialog.vue?vue&type=script&lang=js&"
import style0 from "./ExchangePrizeDialog.vue?vue&type=style&index=0&id=8667d3ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8667d3ea",
  null
  
)

export default component.exports